import { useHttpClient } from "../http-client";
import React from "react";
import { useGetCurrentUserApi } from "./use-get-current-user-api";

export const useStopImpersonatingApi = () => {
  const httpClient = useHttpClient();
  const { refetch } = useGetCurrentUserApi();

  return React.useCallback(async () => {
    await httpClient.post("/classifier/users/stop_impersonating");
    refetch();
  }, []);
};
